import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const slides = [
  {
    desktop: 'https://www.stercodigitex.com/uploads/home/banner_images/1735636834_a3416b5d0279e6b1dbe3.webp',
    mobile: 'https://www.stercodigitex.com/uploads/home/banner_images/1736246347_aebea0ce138f9fdfe7f6.webp',
    caption: (
      <p className="text-2xl md:text-4xl font-bold text-white drop-shadow-lg">
        We Create Imposing <b>Web Experiences</b> <br />That Empower Your Online Presence
      </p>
    ),
  },
  {
    desktop: 'https://www.stercodigitex.com/uploads/home/banner_images/1735636861_954406521215da931fba.webp',
    mobile: 'https://www.stercodigitex.com/uploads/home/banner_images/1736246280_26b42d1edd8b9c6f0f02.webp',
    caption: (
      <p className="text-2xl md:text-4xl font-bold text-white drop-shadow-lg">
        Accelerate Your <b>Brand Ambitions</b> <br />with us
      </p>
    ),
  },
  {
    desktop: 'https://www.stercodigitex.com/uploads/home/banner_images/1735636879_9afbdb772caed09df652.webp',
    mobile: 'https://www.stercodigitex.com/uploads/home/banner_images/1736246411_c6f8d2464f0e4f1fbe8b.webp',
    caption: (
      <p className="text-2xl md:text-4xl font-bold text-white drop-shadow-lg">
        We Bring <b>Your Story to Life,</b> and <br /><b>Life to Your Story</b>
      </p>
    ),
  },
  {
    desktop: 'https://www.stercodigitex.com/uploads/home/banner_images/1735636900_ef92d6857b97ea393aaf.webp',
    mobile: 'https://www.stercodigitex.com/uploads/home/banner_images/1736246480_dd83f068c93785dfed97.webp',
    caption: (
      <p className="text-2xl md:text-4xl font-bold text-white drop-shadow-lg">
        Our solutions: your path to <br /><b>business excellence</b>
      </p>
    ),
  },
];

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[400px] md:min-h-[600px] overflow-hidden">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          bulletClass: 'swiper-pagination-bullet !bg-white/50 !w-3 !h-3 !mx-1',
          bulletActiveClass: 'swiper-pagination-bullet-active !bg-white !w-8',
        }}
        speed={1000}
        effect="fade"
        className="h-full"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div className="relative w-full h-[400px] md:h-[600px] flex items-center justify-center">
              <picture>
                <source media="(min-width:992px)" srcSet={slide.desktop} />
                <img
                  src={slide.mobile}
                  alt="Hero image - Leading web development company in India"
                  className="absolute inset-0 w-full h-full object-cover object-center z-0"
                  loading="lazy"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60 z-10" />
              <div className="relative z-20 flex flex-col items-center justify-center h-full w-full text-center px-4">
                <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 drop-shadow-lg animate-fade-in">
                  Best Website Development Company in India
                </h1>
                <div className="animate-slide-up">
                  {slide.caption}
                </div>
                <div className="mt-8 animate-bounce-in">
                  <a
                    href="#contact"
                    className="inline-block text-white px-8 py-3 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 text-lg font-semibold"
                    style={{ backgroundColor: 'rgb(17, 53, 77)' }}
                  >
                    Get a Quote
                  </a>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      
      {/* Custom Styles */}
      <style>{`
        .swiper-pagination {
          bottom: 20px !important;
        }
        .swiper-pagination-bullet {
          transition: all 0.3s ease !important;
        }
        .swiper-pagination-bullet-active {
          transform: scale(1.2) !important;
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounce-in {
          from { opacity: 0; transform: scale(0.8); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        .animate-slide-up {
          animation: slide-up 1s ease-out 0.3s both;
        }
        .animate-bounce-in {
          animation: bounce-in 0.8s ease-out 0.6s both;
        }
      `}</style>
    </section>
  );
}
